import PropertyType from '../Modifiers/PropertyType.js';

var ThemePageBackgroundValue = new PropertyType({
  name: 'PageBackgroundValue',
  propertyFromApi: 'page-background-value'
}, 'theme');
var FormPageBackgroundValue = new PropertyType({
  name: 'PageBackgroundValue',
  propertyFromApi: 'page-background-value'
}, 'form');

export { FormPageBackgroundValue, ThemePageBackgroundValue };
//# sourceMappingURL=PageBackgroundValue.js.map
